import React from "react";
import { FormattedMessage, useIntl } from "react-intl";
import Instructions from "./Instructions";
import styled from "styled-components";
import { Button, Icon } from "@vitalsource/vstui";
import { useBrand } from "../../../../../../common/providers/brand/brand-context";
import { ChromeBookIcon, WindowsIcon, IosIcon } from "./Icons";
import { cloud } from "@vitalsource/vstui/colors";
import { styledSmallMediaQuery } from "../../../default-mobile/common/mobileBreakpoints";

const Styled = {
  Header: styled.h2`
    color: #ffffff;
    font-size: 40px;
    line-height: 48px;
    text-align: center;
    margin-top: 48px;
    font-weight: 500;
    padding: 0 20px;
  `,
  Instructions: styled(Instructions)`
    position: relative;
    margin: auto;
    margin-top: 72px;
    max-width: 951px;
    padding: 0 16px;
    ${styledSmallMediaQuery({ width: "100%" })};
  `,
  Note: styled.div`
    margin-top: 32px;
    color: ${cloud.getShade(10)};
    font-size: 20px;
    line-height: 24px;
    text-align: center;
    font-weight: 500;
  `,
  InlineLinks: styled.div`
    text-align: center;
    margin: 16px auto;
    font-size: 16px;
    > * {
      margin-right: 24px;
    }
  `,
};

interface QRScreenProps {
  onRequestLaunchApp: (...args) => void;
}

const QRScreen: React.FC<QRScreenProps> = ({ onRequestLaunchApp }) => {
  const intl = useIntl();
  const brand = useBrand();
  const macUrl: string = brand.getProp("DownloadOffline.mac_url");
  const windowsUrl: string = brand.getProp("DownloadOffline.wins_url");
  const googlePlay: string = brand.getProp("DownloadOffline.android_url");

  return (
    <div>
      <Styled.Header>
        <FormattedMessage id="QRDownloadApps.downloadBookShelf"></FormattedMessage>
      </Styled.Header>
      <Styled.Instructions />
      <Styled.Note>
        <FormattedMessage id="QRDownloadApps.downloadForDesktop"></FormattedMessage>
      </Styled.Note>
      <Styled.InlineLinks>
        {macUrl && (
          <Button
            onClick={() => {
              onRequestLaunchApp({
                downloadUrl: macUrl,
              });
            }}
            inline
            target="_blank"
            data-interaction-id={"download_app_mac_support"}
            iconStart={
              <Icon width={20} height={24}>
                <IosIcon />
              </Icon>
            }
          >
            {intl.formatMessage({ id: "base.device.mac" })}
          </Button>
        )}
        {windowsUrl && (
          <Button
            onClick={() => {
              onRequestLaunchApp({
                downloadUrl: windowsUrl,
              });
            }}
            inline
            target="_blank"
            data-interaction-id={"download_app_windows"}
            iconStart={
              <Icon width={23} height={23}>
                <WindowsIcon />
              </Icon>
            }
          >
            {intl.formatMessage({ id: "base.device.windows" })}
          </Button>
        )}
        {googlePlay && (
          <Button
            onClick={() => {
              onRequestLaunchApp({
                downloadUrl: googlePlay,
              });
            }}
            target="_blank"
            inline
            data-interaction-id={"download_app_google_play"}
            iconStart={
              <Icon width={22} height={23}>
                <ChromeBookIcon />
              </Icon>
            }
          >
            {intl.formatMessage({ id: "base.device.chromebook" })}
          </Button>
        )}
      </Styled.InlineLinks>
    </div>
  );
};

export default QRScreen;
